import { defineMessages } from 'react-intl';

export default defineMessages({

  areYouClaimingForAccidentalDeathAndDismemberment: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.areYouClaimingForAccidentalDeathAndDismemberment',
    defaultMessage: 'Are you claiming for Accidental Death & Dismemberment?',
  },
  areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment',
    defaultMessage: 'Are you claiming for Common Carrier Accidental Death & Dismemberment??',
  },
  groupName: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.groupName',
    defaultMessage: 'Groups Name',
  },
  claimantSection: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.claimantSection',
    defaultMessage: 'Claimant Section',
  },
  relationshipToInsured: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.relationshipToInsured',
    defaultMessage: 'Relationship To Insured',
  },
  self: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.self',
    defaultMessage: 'Self',
  },
  spouse: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.spouse',
    defaultMessage: 'Spouse',
  },
  child: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.child',
    defaultMessage: 'Child',
  },
  other: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.other',
    defaultMessage: 'Other',
  },
  placeWhereAccidentHappened: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.placeWhereAccidentHappened',
    defaultMessage: 'Place where accident happened',
  },
  cityOrTown: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.cityOrTown',
    defaultMessage: 'City or Town',
  },
  country: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.country',
    defaultMessage: 'Country',
  },
  state: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.state',
    defaultMessage: 'State',
  },
  postalCode: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.postalCode',
    defaultMessage: 'Postal Code',
  },
  phoneNumber: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.phoneNumber',
    defaultMessage: 'Phone Number',
  },
  dateOfAccident: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.dateOfAccident',
    defaultMessage: 'Date Of Accident',
  },
  describeHowTheAccidentOccurred: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.describeHowTheAccidentOccurred',
    defaultMessage: 'Describe how the Accident occurred',
  },
  dateOfDismembermentOrLossOfUse: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.dateOfDismembermentOrLossOfUse',
    defaultMessage: 'Date of Dismemberment/Loss of Use',
  },
  dateOfDeath: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.dateOfDeath',
    defaultMessage: 'Date of Death',
  },
  hospitalConfined: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.hospitalConfined',
    defaultMessage: 'Hospital Confined',
  },
  dates: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.dates',
    defaultMessage: 'Dates',
  },
  hospital: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.hospital',
    defaultMessage: 'Hospital',
  },

  yes: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.yes',
    defaultMessage: 'Yes',
  },

  no: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.no',
    defaultMessage: 'No',
  },

  isRequired: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },

  address: {
    id: 'fastCover.accidentalDeathAndDismembermentStep.address',
    defaultMessage: 'Address',
  },

});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/messages.js